<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/dashboard/' }"
        >首页</el-breadcrumb-item
      >
      <el-breadcrumb-item>QA管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :span="2">
          <el-button type="success" @click="addDialogVisible = true"
            >添加QA</el-button
          >
        </el-col>
      </el-row>

      <el-table
        :data="tableData"
        style="width: 100%"
        border
        stripe
        v-loading="loading"
        element-loading-text="数据加载中"
        highlight-current-row
      >
        <el-table-column type="index" fixed></el-table-column>
        <el-table-column
          prop="question"
          label="问题"
          fixed
        >
        </el-table-column>
        <el-table-column prop="answer" label="回答">
        </el-table-column>
        <!-- <el-table-column prop="updateTime" label="更新时间" width="180">
        </el-table-column> -->
        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              @click="edit(scope.row.id)"
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="_delete(scope.row.id)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.currentPage"
        :page-sizes="[5, 10, 20, 50, 100]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 添加用户的对话框 -->
    <el-dialog
      :visible.sync="addDialogVisible"
      width="50%"
      @close="addDialogClosed"
    >
      <!-- 内容主体区域 -->
      <el-form
        :model="addForm"
        :rules="addFormRules"
        ref="addFormRef"
        label-width="120px"
      >
        <el-form-item label="问题" prop="question">
          <el-input type="textarea" :autosize="{minRows:4}" v-model="addForm.question"></el-input>
        </el-form-item>
        <el-form-item label="回答" prop="answer">
          <el-input type="textarea" :autosize="{minRows:4}" v-model="addForm.answer"></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="add()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 添加用户的对话框 -->
    <el-dialog
      :visible.sync="editDialogVisible"
      width="50%"
      @close="editDialogClosed"
    >
      <!-- 内容主体区域 -->
      <el-form
        :model="editForm"
        :rules="addFormRules"
        ref="editFormRef"
        label-width="120px"
      >
        <el-form-item label="问题" prop="question">
          <el-input type="textarea" :autosize="{minRows:4}" v-model="editForm.question"></el-input>
        </el-form-item>
        <el-form-item label="回答" prop="answer">
          <el-input type="textarea" :autosize="{minRows:4}" v-model="editForm.answer"></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save()">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      managerOptions: [],
      select: '2',
      // 查询参数
      queryInfo: {
        ReferralCodeName: '',
        pageSize: 5,
        currentPage: 1
      },
      loading: true,
      tableData: [],
      addDialogVisible: false,
      editDialogVisible: false,
      total: 0,
      // 添加的表单数据
      addForm: {
        question: '',
        answer: ''
      },
      editForm: {
        id: '',
        question: '',
        answer: ''
      },
      // 添加表单的验证规则对象
      addFormRules: {
        question: [
          { required: true, message: '请输入问题', trigger: 'blur' }
        ],
        answer: [
          { required: true, message: '请输入回答', trigger: 'blur' }
          // { pattern: /^(0\.(0[1-9]|[1-9]{1,2}|[1-9]0)$)|^1$|^1\.(0[0]|[0]{1,2})$/, message: '请输入0~1的小数', trigger: ['blur', 'change'] }
        ]
      },
      role: ''
    }
  },
  created() {
    this.getQAs()
  },
  methods: {
    async getQAs() {
      await this.$http
        .post('wafer/v1/list_qa/', this.qs.stringify(this.queryInfo))
        .then((res) => {
          // console.log(res)
          if (res.data.status === 0) {
            this.$message.success(res.data.msg)
            this.tableData = res.data.data
            this.total = res.data.total
          } else {
            this.$message.error(res.data.msg)
          }
          //
          this.loading = false
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async add() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return
        // 可以发起添加用户的网络请求
        await this.$http
          .post('wafer/v1/addOrUpdateQA/', this.qs.stringify(this.addForm))
          .then((res) => {
            if (res.data.status === 0) {
              this.$message.success(res.data.msg)
              // 隐藏添加用户的对话框
              this.addDialogVisible = false
              // 重新获取用户列表数据
              this.getQAs()
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch((error) => {
            console.log(error)
            this.$message.error('操作失败！')
          })
      })
    },
    // 展示编辑商品的对话框
    async edit(id) {
      // console.log(id)
      await this.$http
        .get('wafer/v1/get_qa/', {
          params: {
            id: id
          }
        })
        .then((res) => {
          // console.log(res)
          if (res.data.status === 0) {
            this.editForm = res.data.data
            this.editDialogVisible = true
          } else {
            this.$message.error('操作失败！')
          }
        })
        .catch((error) => {
          console.log(error)
          this.$message.error('操作失败！')
        })
    },
    // 监听修改用户对话框的关闭事件
    editDialogClosed() {
      this.$refs.editFormRef.resetFields()
    },
    // 修改用户信息并提交
    save() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return
        // 发起修改用户信息的数据请求
        // console.log(this.editForm)
        await this.$http
          .post('wafer/v1/addOrUpdateQA/', this.qs.stringify(this.editForm))
          .then((res) => {
            if (res.data.status === 0) {
              // 关闭对话框
              this.editDialogVisible = false
              // 刷新数据列表
              this.getQAs()
              // 提示修改成功
              this.$message.success(res.data.msg)
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch((error) => {
            console.log(error)
            this.$message.error('操作失败！')
          })
      })
    },
    async _delete(id) {
      // 弹框询问用户是否删除数据
      const confirmResult = await this.$confirm(
        '此操作将永久删除该数据, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err)
      // 如果用户确认删除，则返回值为字符串 confirm
      // 如果用户取消了删除，则返回值为字符串 cancel
      // console.log(confirmResult)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }

      await this.$http
        .delete('wafer/v1/delete_qa/', {
          params: {
            id: id
          }
        })
        .then((res) => {
          if (res.data.status === 0) {
            this.$message.success('删除成功！')
          } else {
            this.$message.error('操作失败！')
          }
          this.getQAs()
        })
        .catch((error) => {
          console.log(error)
          this.$message.error('操作失败！')
        })
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`)
      this.queryInfo.pageSize = val
      this.getQAs()
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`)
      this.queryInfo.currentPage = val
      this.getQAs()
    },
    search() {
      // 当前页数重置为1
      this.queryInfo.currentPage = 1
      this.getQAs()
    },
    // 监听添加用户对话框的关闭事件
    addDialogClosed() {
      this.$refs.addFormRef.resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
</style>
